export const BG_W = 1920;
export const BG_H = 1080;

// Mirrors the LockedCard backgrounds (lockedCard.css) so the card and meeting background match.
const PALETTES = {
  card_01: { stops: ["#1A1C21", "#0E0F12"], fg: "#F3F2EF", fg2: "#B4B7BE", line: "rgba(243,242,239,0.22)" },
  card_02: { stops: ["#FAF9F6", "#ECEAE4"], fg: "#15161A", fg2: "#55575E", line: "rgba(21,22,26,0.2)" },
  card_03: { stops: ["#0E2142", "#070F22"], fg: "#F2F5FB", fg2: "#A7B6D1", line: "rgba(167,182,209,0.3)" },
  card_04: { stops: ["#EEECE7", "#E6E3DC"], fg: "#17181B", fg2: "#585A60", line: "rgba(23,24,27,0.2)" },
  card_05: { stops: ["#1D1C1A", "#121110"], fg: "#F5F0E7", fg2: "#C2B7A4", line: "rgba(201,169,110,0.45)" },
};
const FONT = '"Plus Jakarta Sans", "Helvetica Neue", Arial, sans-serif';

const loadImage = (src) =>
  new Promise((resolve) => {
    if (!src) return resolve(null);
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = src;
  });

function fitText(ctx, text, maxWidth, size, weight) {
  let s = size;
  do ctx.font = `${weight} ${s}px ${FONT}`;
  while (ctx.measureText(text).width > maxWidth && (s -= 2) > 20);
}

// Identity sits top-left, QR top-right; the centre stays clear for the person on camera.
export async function renderMeetingBackground(canvas, id, { templateId, qrCanvas }) {
  const p = PALETTES[templateId] || PALETTES.card_01;
  canvas.width = BG_W;
  canvas.height = BG_H;
  const ctx = canvas.getContext("2d");
  await document.fonts?.ready;
  const [photo, logo] = await Promise.all([loadImage(id.photoUrl), loadImage(id.logoUrl)]);

  const g = ctx.createLinearGradient(0, 0, BG_W, BG_H);
  g.addColorStop(0, p.stops[0]);
  g.addColorStop(1, p.stops[1]);
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, BG_W, BG_H);

  const x = 120;
  let y = 120;
  if (logo) {
    const h = 64;
    const w = Math.min(240, (logo.width / logo.height) * h);
    ctx.drawImage(logo, x, y, w, (w / logo.width) * logo.height);
    y += 64 + 56;
  }
  let tx = x;
  if (photo) {
    const d = 132;
    ctx.save();
    ctx.beginPath();
    ctx.arc(x + d / 2, y + d / 2, d / 2, 0, Math.PI * 2);
    ctx.clip();
    const s = Math.min(photo.width, photo.height);
    ctx.drawImage(photo, (photo.width - s) / 2, (photo.height - s) / 2, s, s, x, y, d, d);
    ctx.restore();
    tx = x + d + 36;
  }
  ctx.textBaseline = "top";
  ctx.fillStyle = p.fg;
  fitText(ctx, id.fullName || "", 620, 60, 700);
  ctx.fillText(id.fullName || "", tx, y + 6);
  ctx.fillStyle = p.fg2;
  ctx.font = `500 30px ${FONT}`;
  if (id.title) ctx.fillText(id.title, tx, y + 80);
  if (id.company) ctx.fillText(id.company, tx, y + 120);
  ctx.fillStyle = p.line;
  ctx.fillRect(x, y + 190, 360, 2);

  if (qrCanvas && id.qrValue) {
    const tile = 240;
    const qx = BG_W - 120 - tile;
    ctx.fillStyle = "#FFFFFF";
    ctx.beginPath();
    ctx.roundRect ? ctx.roundRect(qx, 120, tile, tile, 20) : ctx.rect(qx, 120, tile, tile);
    ctx.fill();
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(qrCanvas, qx + 16, 136, tile - 32, tile - 32);
    ctx.imageSmoothingEnabled = true;
    ctx.fillStyle = p.fg2;
    ctx.font = `500 22px ${FONT}`;
    ctx.textAlign = "right";
    ctx.fillText(id.publicProfileUrl.replace(/^https?:\/\//, ""), BG_W - 120, 120 + tile + 22);
    ctx.textAlign = "left";
  }
}
